import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ManageBranchService } from "../api/services";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const UserTransactionHistory = () => {
  const navigate = useNavigate();

  // --------------------------------------
  // STATE DECLARATIONS
  // --------------------------------------
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showPickerModal, setShowPickerModal] = useState(false);

  const [superAdmin_id, setSuperAdminId] = useState("");

  const [monthlyTransactions, setMonthlyTransactions] = useState([]); // raw monthly API
  const [dailyTransactions, setDailyTransactions] = useState([]); // daily filtered

  const [activeTab, setActiveTab] = useState("monthly");
  const [isLoading, setIsLoading] = useState(false);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
    const thStyle = {
    padding: "12px",
    fontWeight: "600"
  };

const tdStyle = {
  padding: "12px",
  textAlign: "center",
  border: "1px solid #e5e7eb",
  color: "#111827",
  fontSize: "14px",
};


  // --------------------------------------
  // HELPERS
  // --------------------------------------
  const [totalTransactions, setTotalTransactions] = useState(0);

  const getMonthLabel = (date) =>
    date.toLocaleString("default", { month: "long", year: "numeric" });

  const formatMonthYear = (date) => {
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const y = date.getFullYear();
    return `${m}-${y}`;
  };

  const formatDate = (date) => {
    const d = String(date.getDate()).padStart(2, "0");
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const y = date.getFullYear();
    return `${y}-${m}-${d}`;
  };

  // --------------------------------------
  // FETCH MONTHLY API
  // --------------------------------------
  const fetchTransactionsForMonth = (userId, date) => {
    const payload = {
      user_id: userId,
      month: formatMonthYear(date),
    };

    setIsLoading(true);

    ManageBranchService.get_user_transactions(payload)
      .then((res) => {
        const monthly = res.data.results || [];
        // Calculate total CREDIT amount for the month
        const totalAmount = monthly.reduce((sum, tx) => {
          return sum + Number(tx.amount || 0);
        }, 0);


        setMonthlyTransactions(monthly);
        setTotalTransactions(totalAmount); 
        // Filter daily based on current selectedDate
        filterDailyTransactions(date, monthly);

        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Fetch failed:", err);
        setMonthlyTransactions([]);
        setDailyTransactions([]);
        setIsLoading(false);
      });
  };

  // --------------------------------------
  // FILTER DAILY
  // --------------------------------------
 const filterDailyTransactions = (day, source = monthlyTransactions) => {
  const filtered = monthlyTransactions.filter((tx) => {
    // FIX: parse date safely
    const txDate = new Date(tx.transaction_time.replace(" ", "T"));

    return (
      txDate.getFullYear() === day.getFullYear() &&
      txDate.getMonth() === day.getMonth() &&
      txDate.getDate() === day.getDate()
    );
  });

  setDailyTransactions(filtered);
  setCurrentPage(1);
};


  // --------------------------------------
  // CHANGE DAY (Prev / Next)
  // Always call monthly API from new day’s month
  // --------------------------------------
  const changeDay = (direction) => {
    debugger
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() + direction);

    setSelectedDate(newDate);

    // Call API every time day changes
    fetchTransactionsForMonth(superAdmin_id, newDate);
  };

  // --------------------------------------
  // CHANGE MONTH
  // --------------------------------------
  const handleMonthChange = (direction) => {
    const newDate = new Date(selectedMonth);
    newDate.setMonth(newDate.getMonth() + direction);

    setSelectedMonth(newDate);
    fetchTransactionsForMonth(superAdmin_id, newDate);
  };

  // --------------------------------------
  // ON LOAD
  // --------------------------------------
  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (!token) navigate("/");

    const userId = localStorage.getItem("admin_id");
    setSuperAdminId(userId);

    fetchTransactionsForMonth(userId, selectedMonth);
  }, []);

  // --------------------------------------
  // PAGINATION
  // --------------------------------------
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const paginatedDaily = dailyTransactions.slice(firstIndex, lastIndex);
  const totalPages = Math.ceil(dailyTransactions.length / recordsPerPage);

  // --------------------------------------
  // MONTH PICKER MODAL
  // --------------------------------------
  const renderDatepickerModal = () =>
    showPickerModal && (
      <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">Select Month</h5>
              <button className="btn-close" onClick={() => setShowPickerModal(false)} />
            </div>

            <div className="modal-body text-center">
              <DatePicker
                selected={selectedMonth}
                onChange={(date) => setSelectedMonth(date)}
                showMonthYearPicker
                dateFormat="MM/yyyy"
                inline
              />
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowPickerModal(false)}>
                Cancel
              </button>

              <button
                className="btn btn-primary"
                onClick={() => {
                  fetchTransactionsForMonth(superAdmin_id, selectedMonth);
                  setShowPickerModal(false);
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    );

  // --------------------------------------
  // UI
  // --------------------------------------
  return (
    <div className="container mt-4">
      {/* Loader */}
      {isLoading && (
        <div className="loader">
          <div className="lds-spinner">
            {Array(12)
              .fill()
              .map((_, i) => (
                <div key={i}></div>
              ))}
          </div>
        </div>
      )}

      <button className="btn btn-outline-secondary mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "monthly" ? "active" : ""}`}
            onClick={() => setActiveTab("monthly")}
          >
            Monthly Summary
          </button>
        </li>

        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "daily" ? "active" : ""}`}
            onClick={() => setActiveTab("daily")}
          >
            Daily Summary
          </button>
        </li>
      </ul>

      {/* MONTHLY TAB */}
      {activeTab === "monthly" && (
        <>
          <div
            style={{
              background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
              padding: "18px 20px",
              borderRadius: "16px",
              marginBottom: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
              color: "white",
              boxShadow: "0 4px 6px rgba(0,0,0,0.12)",
            }}
          >
            {/* TITLE */}
            <h5
              style={{
                margin: 0,
                fontWeight: "600",
                fontSize: "16px",
              }}
            >
              Monthly Transactions
            </h5>
          
            {/* MONTH CONTROLS */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "14px",
              }}
            >
              <button
                className="btn btn-outline-light btn-sm rounded-circle border-0"
                onClick={() => handleMonthChange(-1)}
                aria-label="Previous month"
              >
                <FaArrowLeft />
              </button>
          
              <span
                onClick={() => setShowPickerModal(true)}
                style={{
                  fontWeight: "700",
                  fontSize: "15px",
                  cursor: "pointer",
                  padding: "6px 16px",
                  borderRadius: "20px",
                  background: "rgba(255,255,255,0.2)",
                }}
              >
                {getMonthLabel(selectedMonth)}
              </span>
          
              <button
                className="btn btn-outline-light btn-sm rounded-circle border-0"
                onClick={() => handleMonthChange(1)}
                aria-label="Next month"
              >
                <FaArrowRight />
              </button>
            </div>
          </div>
          {/* total summary */}
           <div className="text-center py-2">
              <h6 className="fw-bold">
                Transactions {monthlyTransactions.length} of {totalTransactions}{" "}
                <span className="text-success">↑</span>
              </h6>
            </div>

          {/* Monthly Table */}
          <div  style={{
              marginTop: "30px",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "16px",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            }}
          >
            <table  style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead className="table-warning">
                <tr style={{
                      background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                      textAlign: "center",
                      color: "white"
                    }}>
                  <th style={thStyle}>Date</th>
                  <th style={thStyle}>Transaction ID</th>
                  <th style={thStyle}>By</th>
                  <th style={thStyle}>To</th>
                  <th style={thStyle}>Amount</th>
                  <th style={thStyle}>Type</th>
                </tr>
              </thead>

              <tbody>
                {monthlyTransactions.length > 0 ? (
                  monthlyTransactions.map((txn) => (
                    <tr key={txn.transaction_id}>
                      <td  style={tdStyle}>{txn.transaction_time}</td>
                      <td  style={tdStyle}>{txn.transaction_id}</td>
                      <td  style={tdStyle}>{txn.by_name}</td>
                      <td  style={tdStyle}>{txn.to_name}</td>
                      <td  style={tdStyle}>{txn.amount}</td>
                      <td  style={tdStyle}>{txn.transaction_type}</td>
                    </tr>
                  ))
                ) : (
                  <tr className="text-center">
                    <td colSpan="6">No transactions found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* DAILY TAB */}
      {activeTab === "daily" && (
        <>
           <div
                style={{
                  background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                  padding: "18px 20px",
                  borderRadius: "16px",
                  marginBottom: "20px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "10px",
                  color: "white",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.12)",
                }}
              >
                {/* TITLE */}
                <h5
                  style={{
                    margin: 0,
                    fontWeight: "600",
                    fontSize: "16px",
                  }}
                >
                  Daily Summary
                </h5>
          
                {/* DATE CONTROLS */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                  }}
                >
                  <button
                    className="btn btn-outline-light btn-sm rounded-circle border-0"
                    onClick={() => changeDay(-1)}
                    aria-label="Previous day"
                  >
                    <FaArrowLeft />
                  </button>
          
                  <div
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "20px",
                      padding: "2px 8px",
                    }}
                  >
                    <DatePicker
                      selected={selectedDate}
                      onChange={(date) => {
                      setSelectedDate(date);
                      fetchTransactionsForMonth(superAdmin_id, date);
                      }}
                      dateFormat="dd/MM/yyyy"
                      className="form-control form-control-sm border-0 text-center fw-bold"
                      style={{
                         background: "rgba(255,255,255,0.2)"
                       
                      }}
                    />
                  </div>
          
                  <button
                    className="btn btn-outline-light btn-sm rounded-circle border-0"
                    onClick={() => changeDay(1)}
                    aria-label="Next day"
                  >
                    <FaArrowRight />
                  </button>
                </div>
              </div>

          {/* Daily Table */}
          <div style={{
              marginTop: "30px",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "16px",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            }}>
            <table  style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead className="table-primary">
                <tr  style={{
                      background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                      textAlign: "center",
                      color: "white"
                    }}>
                 <th style={thStyle}>Date</th>
                  <th style={thStyle}>Transaction ID</th>
                  <th style={thStyle}>By</th>
                  <th style={thStyle}>To</th>
                  <th style={thStyle}>Amount</th>
                  <th style={thStyle}>Type</th>
                </tr>
              </thead>

              <tbody>
                {paginatedDaily.length > 0 ? (
                  paginatedDaily.map((txn) => (
                    <tr key={txn.transaction_id}>
                       <td  style={tdStyle}>{txn.transaction_time}</td>
                      <td  style={tdStyle}>{txn.transaction_id}</td>
                      <td  style={tdStyle}>{txn.by_name}</td>
                      <td  style={tdStyle}>{txn.to_name}</td>
                      <td  style={tdStyle}>{txn.amount}</td>
                      <td  style={tdStyle}>{txn.transaction_type}</td>
                    </tr>
                  ))
                ) : (
                  <tr className="text-center">
                    <td colSpan="6">No transactions found for this date.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {dailyTransactions.length > 10 && (
            <div className="d-flex justify-content-center mt-3">
              <button
                className="btn btn-outline-primary mx-2"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Prev
              </button>

              <span className="fw-bold">
                {currentPage} / {totalPages}
              </span>

              <button
                className="btn btn-outline-primary mx-2"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>
          )}
        </>
      )}

      {renderDatepickerModal()}
    </div>
  );
};

export default UserTransactionHistory;
